export enum AnalysisType {
  ROLLING = 'ROLLING',
  SINGLE_PERIOD = 'SINGLE_PERIOD',
}
